import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { HomeScreen } from '../templates/screens/HomeScreen';
import { GameV2Configuration } from '../common-types/ScreensConfigurations.type';
import { CommonStyle } from '../common-types/CommonDataConfig.type';
import { StyleContext } from '../utils/contexts/style.context';
import { apiServiceInstance } from '../utils/services/ApiService';
import { InformationContext, InformationType } from '../utils/contexts/information.context';


export const Preview: React.FunctionComponent = () => {
  const [informationContext, setInformationContext] = useState<InformationType>({});
  const { campaignId } = useParams<{ campaignId: string | undefined }>();
  const [
    configurations,
    setConfigurations,
  ] = useState<GameV2Configuration | null>(null);
  const [
    style,
    setStyle,
  ] = useState<CommonStyle | null>(null);

  useEffect(() => {
    if (typeof campaignId === 'string') {
      apiServiceInstance.fetchPreviewData(campaignId).then((fetchResult) => {
        setConfigurations(fetchResult.gameConfig.screens);
        setStyle(fetchResult.siteConfig.commons.style);
        setInformationContext({
          campaign: fetchResult.campaign,
          ticket: fetchResult.ticket,
          site: fetchResult.site,
        });
      });
    }
  }, [campaignId]);

  return (
    <InformationContext.Provider value={{
      information: informationContext,
      setInformation: setInformationContext,
    }}>
      <StyleContext.Provider value={{
        setStyle,
        style,
      }}>
        {
          configurations !== null &&
          <HomeScreen config={configurations.home} />
        }
      </StyleContext.Provider>
    </InformationContext.Provider>
  );
};
